import React, { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ToastChakra } from "../../helpers/toast";
import {
  Box,
  HStack,
  Image,
  IconButton,
  Stack,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Text,
  Tooltip,
  VStack,
  Flex
} from "@chakra-ui/react";
import { FaArrowLeft } from "react-icons/fa";
import logoIE from "../../assets/img/logo_nery.jpg";
import moment from "moment";
import { useReactToPrint } from "react-to-print";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { Loading } from "../../helpers/Loading";
import {
  BsFillCloudDownloadFill,
  BsFillImageFill,
} from "react-icons/bs";

import { useLocation } from "react-router-dom";
import { getFacturaById } from "../../features/facturaVentaSlice"; // Asegúrate de tener esta acción en tu slice
import { getConfiguraciones } from "../../features/configuracionesSlice";

const FacturaPdf = () => {
  const componentRef = useRef();
  const { id } = useParams(); // Obtén el ID de la URL
  const location = useLocation(); // Obtén el estado de navegación
  const dispatch = useDispatch();

  const [isPdfMode, setIsPdfMode] = useState(false);


  // Estado local para la factura
  const [factura, setFactura] = useState(location.state?.factura || null);
  const {
    isLoading,
    factura: facturaFromStore,
    isError,
    message,
  } = useSelector((state) => state.facturas);

  const {configuracionesList} = useSelector((state) => state.configuraciones);

  const [loadingDowloadPdf, setloadingDowloadPdf] = useState(false);
  const [loadingDowloadImage, setloadingDowloadImage] = useState(false);

  useEffect(() => {
    // Si no hay datos de la factura en el estado, carga desde el backend
    if (!factura) {
      dispatch(getFacturaById(id));
      dispatch(getConfiguraciones());
    }
  }, [factura, id, dispatch]);

  useEffect(() => {
    // Actualiza la factura cuando se cargue desde el backend
    if (facturaFromStore) {
      setFactura(facturaFromStore);
    }
  }, [facturaFromStore]);

  useEffect(() => {
    if (isError) {
      ToastChakra("Error", message, "error", 1500);
      console.log(message);
    }
  }, [isError, message]);


  const handleDownloadPdf = () => {
    const element = componentRef.current;
  
    setloadingDowloadPdf(true);
  
    const waitForImages = () => {
      const images = element.querySelectorAll("img");
      return Promise.all(
        Array.from(images).map((img) => {
          if (img.complete) return Promise.resolve();
          return new Promise((resolve) => {
            img.onload = img.onerror = resolve;
          });
        })
      );
    };
  
    const waitForFonts = () => {
      if (document.fonts && document.fonts.ready) {
        return document.fonts.ready;
      }
      return Promise.resolve();
    };
  
    Promise.all([waitForImages(), waitForFonts()])
      .then(() => {
        return html2canvas(element, {
          scale: 2,
          useCORS: true,
          backgroundColor: "#fff",
          scrollY: 0, // Muy importante si hay scrolls
          windowWidth: document.documentElement.offsetWidth,
          windowHeight: document.documentElement.offsetHeight,
        });
      })
      .then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF({
          orientation: "portrait",
          unit: "pt",
          format: "a4",
        });
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
  
        pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
        pdf.save(`Factura_nro_${factura?.numero}.pdf`);
        setloadingDowloadPdf(false);
      })
      .catch((error) => {
        console.error("Error generando PDF:", error);
        setloadingDowloadPdf(false);
      });
  };
  
  const handleDownloadImage = () => {
    setloadingDowloadImage(true);
    const element = componentRef.current;
    // Configuración de renderizado de html2canvas
    const options = {
      id: "html2canvas", // ID del elemento a renderizar
      scale: 6, // Aumenta la resolución de la imagen (2x)
      useCORS: true, // Habilita el uso de CORS para imágenes externas
      logging: true, // Habilita el registro de mensajes de html2canvas en la consola
      type: "image/png", // Tipo de imagen a generar
      quality: 0.92, // Calidad de la imagen (0 - 1)
      allowTaint: false, // Habilita el renderizado de elementos sobre los que se ha aplicado estilos
      backgroundColor: "#fff", // Color de fondo de la imagen
      removeContainer: true, // Elimina el contenedor generado por html2canvas
      imageTimeout: 15000, // Tiempo máximo de espera para la carga de imágenes, en milisegundos
      foreignObjectRendering: false, // Habilita el renderizado de elementos SVG
      async: true, // Habilita el renderizado asíncrono
      allowTainttaintTest: false, // Habilita el renderizado de elementos sobre los que se ha aplicado estilos
      proxy: null, // URL del proxy a utilizar
      svgRendering: false, // Habilita el renderizado de elementos SVG
    };

    html2canvas(element, options).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const link = document.createElement("a");
      link.href = imgData;
      link.download = `Factura_nro_${factura?.numero}.png`;
      setloadingDowloadImage(false);
      link.click();
    });
  };

  if (isLoading) {
    return <Loading />;
  }
  return (
    <>
      <Stack spacing={4} direction="row" justifyContent="space-between" py={4}>
        <HStack spacing={4} direction="row">
          <Link to={"/factura_venta"}>
            <IconButton
              icon={<FaArrowLeft />}
              colorScheme="gray"
              rounded="full"
            />
          </Link>
          <Text fontSize={{ base: "xs", lg: "md" }} fontWeight={"bold"}>
            Regresar
          </Text>
        </HStack>
        <HStack spacing={2} direction="row">
 
          <Tooltip hasArrow label="Descargar en PDF" placement="auto">
            <IconButton
              size="md"
              isLoading={loadingDowloadPdf ? true : false}
              colorScheme="green"
              _dark={{
                bg: "green.500",
                color: "white",
                _hover: {
                  bg: "green.700",
                },
              }}
              borderRadius={"xl"}
              onClick={handleDownloadPdf}
              icon={<BsFillCloudDownloadFill fontSize={20} />}
            />
          </Tooltip>
          <Tooltip hasArrow label="Descargar en Imagen" placement="auto">
            <IconButton
              size="md"
              isLoading={loadingDowloadImage ? true : false}
              colorScheme="blue"
              _dark={{
                bg: "blue.500",
                color: "white",
                _hover: {
                  bg: "blue.700",
                },
              }}
              borderRadius={"xl"}
              onClick={handleDownloadImage}
              icon={<BsFillImageFill fontSize={20} />}
            />
          </Tooltip>
        </HStack>
      </Stack>

      <Box
        ref={componentRef}
        //w="full"
        bg="white"
        w="210mm"
        minH="297mm"
        color="black"
        p={6}
        mx="auto"
        fontFamily="Arial, sans-serif"
        fontSize="14px"
      >
        {/* ENCABEZADO - FILA 1 */}
        <HStack spacing={3} align="stretch" mb={3}>
          {/* Columna izquierda */}
          <Box border="2px solid black" borderRadius="md" p={4} w="50%">
            <VStack spacing={1} textAlign="center">
            <Image
              src={configuracionesList.logo || logoIE}
              alt="logo"
              style={{
                width: "60px",
                height: "60px",
                objectFit: "contain",
                display: "block",      // evita line-height o espacio bajo img
              }}
            />
              <Text fontWeight="bold" fontStyle="italic">
              {configuracionesList.nombre}
              </Text>
              <Text fontSize="sm">
              {configuracionesList.direccion}
              </Text>
              <HStack fontSize="sm">
                <Text>
                  <strong>NIF :</strong>  {configuracionesList.dni}
                </Text>
                <Text>
                  <strong>Tel :</strong>  {configuracionesList.telefono}
                </Text>
              </HStack>
              <Text fontWeight="bold"> {configuracionesList.ciudad}</Text>
            </VStack>
          </Box>

          {/* Columna derecha */}
          <Box border="2px solid black" borderRadius="md" p={4} w="50%">
            <VStack align="start" spacing={1}>
              <Text fontWeight="bold">{factura?.cliente}</Text>
              <Text>{factura?.direccion}</Text>
              <Text fontWeight="bold">{factura?.ciudad}</Text>
            </VStack>
            <Text
              fontSize="2xl"
              fontWeight="bold"
              textAlign="center"
              letterSpacing="widest"
              mt={10}
            >
              F A C T U R A
            </Text>
          </Box>
        </HStack>

        {/* INFO CLIENTE / FACTURA */}
        <HStack spacing={6} align="stretch" mb={2}>
          <Box border="2px solid black" borderRadius="md" p={4} w="100%">
            <Flex justify="space-between" wrap="wrap" w="100%">
              <Text>
                <strong>Fecha:</strong> {moment(factura?.fechaFactura).format("DD/MM/YYYY")}
              </Text>
              <Text>
                <strong>Factura N°:</strong> {factura?.numero}
              </Text>
              <Text>
                <strong>Cliente:</strong> {factura?.cliente}
              </Text>
              <Text>
                <strong>C.I.F / N.I.F:</strong> {factura?.dni}
              </Text>
              <Text>
                <strong>Teléfono:</strong> {factura?.celular}
              </Text>
            </Flex>
          </Box>
        </HStack>

      {/* CABECERA DE LA TABLA */}
      <Box border="2px solid black" borderRadius="md" p={4} w="100%">
        <Table width="100%" size="sm" __css={{ borderCollapse: 'collapse' }}>
              <Th
                w="45%" // Coincide con Td
                fontSize="sm"
                fontWeight="bold"
                color="black"
                textAlign="left"
                border="none"
              >
                Descripción
              </Th>
              <Th
                w="8%" // Coincide con Td
                fontSize="sm"
                fontWeight="bold"
                color="black"
                isNumeric
                border="none"
              >
                Cant.
              </Th>
              <Th
                w="18%" // Coincide con Td
                fontSize="sm"
                fontWeight="bold"
                color="black"
                isNumeric
                border="none"
              >
                P. Unitario
              </Th>
              <Th
                w="3%" // Coincide con Td
                fontSize="sm"
                fontWeight="bold"
                color="black"
                isNumeric
                border="none"
              >
                IVA
              </Th>
              <Th
                w="26%" // Coincide con Td
                fontSize="sm"
                fontWeight="bold"
                color="black"
                isNumeric
                border="none"
                textAlign="right"
              >
                Precio Total
              </Th>
        </Table>
      </Box>

      {/* CUERPO DE LA TABLA */}
      <HStack spacing={6} align="stretch" mt={1}> {/* Aquí es donde agregaremos el espacio */}
        <Box
          borderRadius="md"
          height="590px"
          width="100%"
          border="2px solid black"
          overflow="hidden"
        >
            <Table width="100%" tableLayout="fixed" size="sm" __css={{ borderCollapse: 'collapse' }}>
              <Tbody>
                {factura?.detalles.map((item, index) => (
                  <Tr key={index}>
                    <Td
                      w="45%" // Ajustado para coincidir con Th
                      fontSize="xs"
                      borderTop="none"
                      borderBottom="none"
                      borderLeft="1px solid black"
                      borderRight="1px solid black"
                    >
                      {item.descripcion}
                    </Td>
                    <Td
                      w="8%" // Ajustado para coincidir con Th (era 3%)
                      fontSize="xs"
                      isNumeric
                      borderTop="none"
                      borderBottom="none"
                      borderLeft="1px solid black"
                      borderRight="1px solid black"
                    >
                      {item.cantidad}
                    </Td>
                    <Td
                      w="18%" // Ajustado para coincidir con Th (era 15%)
                      fontSize="xs"
                      isNumeric
                      borderTop="none"
                      borderBottom="none"
                      borderLeft="1px solid black"
                      borderRight="1px solid black"
                    >
                      {parseFloat(item.precio_unitario).toLocaleString('es-ES', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                        useGrouping: true,
                      })}
                    </Td>
                    <Td
                      w="3%" // Ajustado para coincidir con Th
                      fontSize="xs"
                      isNumeric
                      borderTop="none"
                      borderBottom="none"
                      borderLeft="1px solid black"
                      borderRight="1px solid black"
                    >
                      {item.iva}%
                    </Td>
                    <Td
                      w="26%" // Ajustado para coincidir con Th (era 30%)
                      fontSize="xs"
                      isNumeric
                      borderTop="none"
                      borderBottom="none"
                      borderLeft="1px solid black"
                      borderRight="1px solid black"
                    >
                      {parseFloat(item.precio_total).toLocaleString('es-ES', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                        useGrouping: true,
                      })}
                    </Td>
                  </Tr>
                ))}

                {/* Rellenar con filas vacías */}
                {Array.from({ length: 20 - (factura?.detalles.length || 0) }).map((_, idx) => (
                  <Tr key={`empty-${idx}`} height="34px">
                    <Td w="45%" borderTop="none" borderBottom="none" borderLeft="1px solid black" borderRight="1px solid black">&nbsp;</Td>
                    <Td w="8%" borderTop="none" borderBottom="none" borderLeft="1px solid black" borderRight="1px solid black">&nbsp;</Td>
                    <Td w="18%" borderTop="none" borderBottom="none" borderLeft="1px solid black" borderRight="1px solid black">&nbsp;</Td>
                    <Td w="3%" borderTop="none" borderBottom="none" borderLeft="1px solid black" borderRight="1px solid black">&nbsp;</Td>
                    <Td w="26%" borderTop="none" borderBottom="none" borderLeft="1px solid black" borderRight="1px solid black">&nbsp;</Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </Box>
        </HStack>

        {/* TOTALES */}
        <HStack spacing={6} align="stretch" mt={1}>
          <Box border="2px solid black" borderRadius="md" p={4} w="100%">
            <Flex justify="space-between" align="start" w="100%" wrap="wrap">
              {/* Stack Izquierdo */}
              <Stack spacing={1}  fontSize="14px">
                <Text>
                  <strong>Forma de pago:</strong> {factura?.condicionPago}
                </Text>
                <Text>
                  <strong>Observaciones:</strong> {factura?.observaciones}
                </Text>
                <Text fontSize="xs" mt={4}>
                {configuracionesList.cuenta}
                </Text>
              </Stack>

              {/* Stack Derecho */}
              <Stack spacing={1} fontWeight="bold" fontSize="14px" align="flex-end">
                <HStack>
                  <Text>Total Base:</Text>
                  <Text>
                    {factura?.detalles
                      .reduce(
                        (sum, item) =>
                         sum + Number(item.precio_unitario) * Number(item.cantidad),
                        0
                      )
                      .toLocaleString('es-ES', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                        useGrouping: true
                      })}{" "}
                    €
                  </Text>
                </HStack>
                <HStack>
                    <Text>Total IVA:</Text>
                    <Text>
                      {factura?.detalles
                         .reduce(
                            (sum, item) => {
                              const base = Number(item.precio_unitario) * Number(item.cantidad);
                              const total = Number(item.precio_total);
                              return sum + (total - base);
                            },
                            0
                          )
                        .toLocaleString('es-ES', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          useGrouping: true
                        })}{" "}
                      €
                    </Text>
                </HStack>
                <HStack>
                  <Text>Total General:</Text>
                  <Text>{parseFloat(factura?.totalGeneral).toLocaleString('es-ES', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                    useGrouping: true
                  })} €</Text>
                </HStack>
              </Stack>
            </Flex>
          </Box>
        </HStack>

        {/* PIE DE PÁGINA */}
    
      </Box>
    </>
  );
};

export default FacturaPdf;